import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').service('registerService', registerService);

    /**
     * @param REGISTRATION_MODE
     * @param COUNTRIES
     * @param countryService
     * @param identifierService
     * @param salutationService
     * @returns {Object}
     * @author flzemke.btc, sikrause.btc, stholly.btc
     * @ngInject
     */
    function registerService(
        REGISTRATION_MODE,
        COUNTRIES,
        countryService,
        identifierService,
        salutationService
    ) {
        return {
            companyName: null,
            companyAddress: null,
            model: { contacts: [] },
            updateModelFromEicResponse: function (
                viewModelCompanyDetails,
                eicRes
            ) {
                viewModelCompanyDetails.dvgwCode =
                    identifierService.getIdentifierFromIdentifierList(
                        eicRes.shipper.identifierList,
                        identifierService.IDENTIFIERS.DVGW
                    );
                viewModelCompanyDetails.companyName = eicRes.shipper.name;
                viewModelCompanyDetails.address.street =
                    eicRes.shipper.address.street;
                viewModelCompanyDetails.address.zipCode =
                    eicRes.shipper.address.zipCode;
                viewModelCompanyDetails.address.city =
                    eicRes.shipper.address.city;
                viewModelCompanyDetails.address.country =
                    this.getCountryByCode(
                        this.countries,
                        eicRes.shipper.address.countryCode
                    ) || null;
                viewModelCompanyDetails.address.poBox =
                    eicRes.shipper.address.poBox;
                viewModelCompanyDetails.address.poBoxZipCode =
                    eicRes.shipper.address.poBoxZipCode;
                viewModelCompanyDetails.address.poBoxCity =
                    eicRes.shipper.address.poBoxCity;
                viewModelCompanyDetails.vatNumber = eicRes.shipper.vatNumber;
                viewModelCompanyDetails.agreedToPublish =
                    eicRes.shipper.agreedToPublish;
            },
            gatherStageInformation: function (
                registerStage,
                farthestRegisterStageIndex
            ) {
                return {
                    registerStage: registerStage,
                    farthestRegisterStageIndex: farthestRegisterStageIndex
                };
            },
            isRegisteredShipper: function (tso) {
                if (angular.isUndefined(tso) || tso === null) {
                    return;
                }
                return tso.mode === REGISTRATION_MODE.REGISTERED_SHIPPER;
            },
            isInReview: function (tso) {
                if (angular.isUndefined(tso) || tso === null) {
                    return;
                }
                return tso.mode === REGISTRATION_MODE.SHIPPER_IN_REVIEW;
            },
            isTso: function (tso) {
                if (angular.isUndefined(tso) || tso === null) {
                    return;
                }
                return tso.mode === REGISTRATION_MODE.TSO;
            },
            isShipper: function (tso) {
                if (angular.isUndefined(tso) || tso === null) {
                    return;
                }
                return tso.mode === REGISTRATION_MODE.NEW_SHIPPER;
            },
            countries: COUNTRIES,
            authMethod: {
                HARDWARE: 'HARDWARE',
                MOBILE: 'MOBILE'
            },
            // TODO The salutationService could be used directly, rather than through registerService
            salutations: salutationService.salutations,
            submitCompanyDetails: function (companyDetails, eic, shipperMode) {
                var company = angular.copy(companyDetails);
                this.model.mode = shipperMode;
                this.model.shipper = {};
                this.model.shipper.name = company.companyName;
                this.model.shipper.identifierList = [];
                this.model.shipper.identifierList.push({
                    type: 'EIC',
                    id: eic
                });
                if (company.dvgwCode && company.dvgwCodeOpt) {
                    this.model.shipper.identifierList.push({
                        type: 'DVGW',
                        id: company.dvgwCode
                    });
                }
                for (var identifierName in company.identifier) {
                    if (!!company.identifier[identifierName].id) {
                        this.model.shipper.identifierList.push(
                            company.identifier[identifierName]
                        );
                    }
                }
                this.model.shipper.address = company.address;
                this.model.shipper.address.countryCode =
                    company.address.country.code;

                if (company.identicalBillingAddress) {
                    this.model.shipper.billingAddress = null;
                } else {
                    company.billingAddress.salutation = angular.uppercase(
                        company.billingAddress.salutation.name
                    );
                    this.model.shipper.billingAddress = company.billingAddress;
                    this.model.shipper.billingAddress.address.countryCode =
                        company.billingAddress.address.country.code;
                    delete this.model.shipper.billingAddress.country;
                    delete this.model.shipper.billingAddress.address.country;
                }

                this.model.shipper.vatNumber = company.vatNumber;
                this.model.shipper.agreedToPublish = company.agreedToPublish;

                if (shipperMode === REGISTRATION_MODE.NEW_SHIPPER) {
                    this.model.shipper.bankAccount = {
                        bank: company.bank,
                        iban: company.iban,
                        bic: company.bic
                    };
                }

                delete this.model.shipper.address.country;
            },
            submitUserDetails: function (userDetails) {
                var user = angular.copy(userDetails);
                user.salutation = angular.uppercase(
                    userDetails.salutation.name
                );
                user.receiveAuctionEmailNotificationOnOpen = false;
                user.receiveAuctionEmailNotificationOnPublish = false;
                user.receiveAuctionEmailNotificationOnUnsuccessful = false;
                user.receiveAuctionEmailNotificationOnPlacedBid = true;
                user.authenticationMethod = userDetails.authMethod;
                delete user.type;
                delete user.communication;
                delete user.dispatchingAddress;
                delete user.poBox;
                delete user.poBoxZipCode;
                delete user.poBoxCity;
                delete user.emailConfirm;

                this.model.user = user;

                delete this.model.user.authMethod;
            },
            submitContact: function (contacts) {
                if (
                    !contacts.DISPATCHING_CENTRAL ||
                    angular.equals(contacts.DISPATCHING_CENTRAL, {}) ||
                    !contacts.DISPATCHING.length ||
                    !contacts.COMMUNICATION.length ||
                    !contacts.BILLING.length ||
                    !contacts.OPERATION.length
                ) {
                    return null;
                }

                var cpContacts = angular.copy(contacts);
                if (
                    !this.model ||
                    !this.model.shipper ||
                    angular.equals(this.model.shipper, {})
                ) {
                    this.model.shipper = {};
                }

                this.model.shipper.dispatchingAddress = {
                    street: cpContacts.DISPATCHING_CENTRAL.dispatchingAddress
                        .streetName,
                    zipCode:
                        cpContacts.DISPATCHING_CENTRAL.dispatchingAddress
                            .zipCode,
                    city: cpContacts.DISPATCHING_CENTRAL.dispatchingAddress
                        .city,
                    countryCode:
                        cpContacts.DISPATCHING_CENTRAL.dispatchingAddress
                            .country.countryCode.code,
                    poBox: cpContacts.DISPATCHING_CENTRAL.poBox,
                    poBoxZipCode: cpContacts.DISPATCHING_CENTRAL.poBoxZipCode,
                    poBoxCity: cpContacts.DISPATCHING_CENTRAL.poBoxCity
                };

                this.model.shipper.dispatchingCommunicationInfo = {
                    phone: cpContacts.DISPATCHING_CENTRAL.communication.phone,
                    phoneBackup:
                        cpContacts.DISPATCHING_CENTRAL.communication
                            .phoneBackup,
                    phoneOnCall:
                        cpContacts.DISPATCHING_CENTRAL.communication
                            .phoneOnCall,
                    fax: cpContacts.DISPATCHING_CENTRAL.communication.fax,
                    email: cpContacts.DISPATCHING_CENTRAL.communication.email
                };

                this.model.shipper.contacts = [];

                for (var contactType in cpContacts) {
                    if (
                        !cpContacts.hasOwnProperty(contactType) ||
                        contactType === 'DISPATCHING_CENTRAL'
                    ) {
                        continue;
                    }

                    for (var i = 0; i < cpContacts[contactType].length; i++) {
                        this.model.shipper.contacts.push({
                            type: contactType,
                            salutation: angular.uppercase(
                                cpContacts[contactType][i].salutation.name
                            ),
                            title: cpContacts[contactType][i].title,
                            section: cpContacts[contactType][i].section,
                            firstName: cpContacts[contactType][i].firstName,
                            lastName: cpContacts[contactType][i].lastName,
                            communication: {
                                phone: cpContacts[contactType][i].communication
                                    .phone,
                                phoneOnCall:
                                    cpContacts[contactType][i].communication
                                        .phoneOnCall,
                                phoneBackup:
                                    cpContacts[contactType][i].communication
                                        .phoneBackup,
                                mobile: cpContacts[contactType][i].communication
                                    .mobile,
                                fax: cpContacts[contactType][i].communication
                                    .fax,
                                email: cpContacts[contactType][i].communication
                                    .email
                            }
                        });
                    }
                }
            },
            submitTsoDetails: function (selectedTsoIds) {
                this.model.tsoAssignmentList = [];

                for (var i = 0; i < selectedTsoIds.length; i++) {
                    this.model.tsoAssignmentList.push({
                        tsoRefId: selectedTsoIds[i].id,
                        marketAreaSupervisorNotification:
                            selectedTsoIds[i].AcceptedDataTransfer
                    });
                }
            },
            submitProxyShipper: function (proxyShipper) {
                this.model.proxyShipper = proxyShipper;
            },
            contactIsShipperUser: function (contact, shipperUser) {
                var convertedShipperUser =
                    this.convertShipperUserToContact(shipperUser);
                return angular.equals(contact, convertedShipperUser);
            },
            convertShipperUserToContact: function (shipperUser) {
                return {
                    salutation: shipperUser.salutation.enum
                        ? shipperUser.salutation
                        : salutationService.getSalutationByEnum(
                              shipperUser.salutation
                          ),
                    firstName: shipperUser.firstName,
                    lastName: shipperUser.lastName,
                    communication: {
                        phone: shipperUser.phone,
                        fax: shipperUser.fax,
                        email: shipperUser.email,
                        mobile: shipperUser.mobile
                    },
                    // extra field, for prisma-7055
                    authMethod: shipperUser.authMethod
                };
            },
            convertContactToShipperUser: function (contact, emailConfirmed) {
                return {
                    salutation: contact.salutation.enum,
                    firstName: contact.firstName,
                    lastName: contact.lastName,
                    phone: contact.communication.phone,
                    fax: contact.communication.fax,
                    email: contact.communication.email,
                    mobile: contact.communication.mobile,
                    emailConfirm: emailConfirmed
                        ? contact.communication.email
                        : null
                };
            },
            // extra function for prisma-7055
            convertContactToShipperUserForRegistration: function (
                contact,
                emailConfirmed
            ) {
                return {
                    salutation: contact.salutation,
                    authMethod: contact.authMethod,
                    firstName: contact.firstName,
                    lastName: contact.lastName,
                    phone: contact.communication.phone,
                    fax: contact.communication.fax,
                    email: contact.communication.email,
                    mobile: contact.communication.mobile,
                    emailConfirm: emailConfirmed
                        ? contact.communication.email
                        : null
                };
            },
            getCountryByCode: function (countries, countryCode) {
                return countryService.getCountryByCode(countries, countryCode);
            },
            getCountryByName: function (countries, countryName) {
                return countryService.getCountryByName(countries, countryName);
            },
            gatherContactsInformation: function (contacts) {
                return {
                    DISPATCHING: contacts.dispatchingContact.contacts,
                    DISPATCHING_CENTRAL:
                        contacts.dispatchingCentralContact.contacts,
                    BILLING: contacts.billingContact.contacts,
                    COMMUNICATION: contacts.communicationContact.contacts,
                    OPERATION: contacts.operationContact.contacts
                };
            },
            restoreContacts: function (filteredContacts, vm) {
                for (var i = 0; i < filteredContacts.length; i++) {
                    for (
                        var k = 0;
                        k < filteredContacts[i].contacts.length;
                        k++
                    ) {
                        switch (filteredContacts[i].contacts[k].type) {
                            case 'DISPATCHING': {
                                vm.dispatchingContact.contacts =
                                    filteredContacts[i].contacts;
                                break;
                            }
                            case 'DISPATCHING CENTRAL': {
                                vm.dispatchingCentralContact.contacts =
                                    filteredContacts[i].contacts;
                                break;
                            }
                            case 'BILLING': {
                                vm.billingContact.contacts =
                                    filteredContacts[i].contacts;
                                break;
                            }
                            case 'COMMUNICATION': {
                                vm.communicationContact.contacts =
                                    filteredContacts[i].contacts;
                                break;
                            }
                            case 'OPERATION': {
                                vm.operationContact.contacts =
                                    filteredContacts[i].contacts;
                                break;
                            }
                        }
                    }
                }
                return vm;
            }
        };
    }
})();
